export default function TaskIcon({ width = 32, height = 32 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 8.88889C0 3.97969 3.97969 0 8.88889 0H23.1111C28.0203 0 32 3.97969 32 8.88889V23.1111C32 28.0203 28.0203 32 23.1111 32H8.88889C3.97969 32 0 28.0203 0 23.1111V8.88889Z'
        fill='#DBFCDE'
      />
      <path
        d='M22 15V20.6667C22 21.0203 21.8595 21.3594 21.6095 21.6095C21.3594 21.8595 21.0203 22 20.6667 22H11.3333C10.9797 22 10.6406 21.8595 10.3905 21.6095C10.1405 21.3594 10 21.0203 10 20.6667V11.3333C10 10.9797 10.1405 10.6406 10.3905 10.3905C10.6406 10.1405 10.9797 10 11.3333 10H19.6667'
        stroke='#077F13'
        stroke-width='1.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M14 15.3346L16 17.3346L22.6667 10.668'
        stroke='#077F13'
        stroke-width='1.33333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
